<template>
  <CContainer class="pt-5 mb-5" fluid>
    <CRow>
      <CCol class="col-12">
        <h3 class="pl-3 mb-0 pb-0">APHT</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/apht/created">
            <CIcon name="cil-file" />
            APHT
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Detail</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
    </CRow>
    <CRow class="mx-2">
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data FIMS</h5>
              </CCol>
              <CCol class="col-12 pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tipe Kontrak</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: APHT</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Nama Office</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.officeName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Status</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: {{ $helper.showData(details.memoStatusName, "string") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Tanggal Pembuatan</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8 mb-4">
                    <p>: {{ $helper.showData(details.createdAt, "shortDate") }}</p>
                  </CCol>
                  <!-- <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Harga Objek</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp{{ $helper.showData(details.objectPrice, "number") }}</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-4 col-md-6 col-lg-6 col-xl-4">
                    <p>Fee Notaris</p>
                  </CCol>
                  <CCol class="col-6 col-xs-6 col-sm-8 col-md-6 col-lg-6 col-xl-8">
                    <p>: Rp{{ $helper.showData(details.notaryFee, "number") }}</p>
                  </CCol> -->
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 col-md-6 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Data FIFApps</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="pt-2 custom-detail-list">
                <CRow v-if="isLoadingAPHT">
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9 mb-1">
                    <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                  </CCol>
                </CRow>
                <CRow v-else>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>No. Appl</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.applNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>No. Kontrak</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.contractNo, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Nama Customer</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: {{ $helper.showData(details.customerName, "string") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Nilai Penjaminan</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: Rp{{ $helper.showData(details.nilaiPenjaminan, "number") }}</p>
                  </CCol>
                  <CCol class="col-5 col-xs-5 col-sm-3 col-md-5 col-lg-5 col-xl-3">
                    <p>Pokok Pembiayaan</p>
                  </CCol>
                  <CCol class="col-7 col-xs-7 col-sm-9 col-md-7 col-lg-7 col-xl-9">
                    <p>: Rp{{ $helper.showData(details.pokokPembiayaan, "number") }}</p>
                  </CCol>
              </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Notes</h5>
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-if="isLoadingAPHT">
                <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
              </CCol>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6" v-else>
                {{ $helper.showData(details.notes, "string") }}
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-7 col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-6">
                <h5 class="custom-header-display">Dokumen Pendukung</h5>
                <!-- <h6 class="mb-0" v-if="isLoadingAPHT"><Skeleton type="rect" :width="'10rem'" :height="'1.69rem'" animation="fade" /></h6>
                <h6 v-else-if="details.documentStatus == 'Y'" class="custom-text-blue">Status Validasi - Y</h6>
                <h6 v-else>Status Validasi - N</h6> -->
              </CCol>
              <template v-if="$helper.isRole($availRoles['Cabang']) || $helper.isRole($availRoles['HO']) || $helper.isRole($availRoles['FIMS'])">
                <CCol class="col-4 col-xs-3 col-sm-3 col-md-2 col-lg-2 col-xl-2  offset-1 offset-xs-1 offset-sm-1 offset-md-2 offset-lg-2 offset-xl-4" v-if="isLoadingAPHT">
                  <Skeleton type="rect" :width="'100%'" :height="'2.38rem'" animation="fade" />
                </CCol>
                <CCol class="col-5 col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-6" v-else>
                  <CButton color="primary" class="float-right" @click="showAddDocumentModal()" :disabled="!details.creator" :title="details.creator ? '' : 'Hanya pembuat kontrak yang dapat melakukan perubahan dokumen'" v-if="$helper.isRole($availRoles['Cabang'])">
                    Add <FaIcon icon="plus" />
                  </CButton>
<!--                   <CButton color="primary" class="float-right mr-2" @click="showReGenerateDocumentModal()">
                    Re-Generate <CIcon name="cil-reload" />
                  </CButton> -->
                </CCol>
              </template>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoadingAPHT">
                  <CRow v-for="index in 5" :key="index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6 mb-1" v-if="($helper.isRole($availRoles['Cabang']))">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-12 mb-1" v-else>
                      <CRow>
                        <CCol class="col-8 col-xs-8 col-sm-6 col-md-5 col-lg-6 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-4 col-xs-4 col-sm-6 col-md-7 col-lg-6 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-5 col-xs-5 col-sm-6 col-md-5 col-lg-5 col-xl-6 text-right mb-1" v-if="($helper.isRole($availRoles['Cabang']))">
                      <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow :class="{custom_row_blue: item.isHovered === true}" v-for="(item, index) in details.listDocument" :key="item.name + '-' + index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6" v-if="($helper.isRole($availRoles['Cabang']))">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <p>{{ item.name }}</p>
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <p class="custom-text-blue" v-if="!$helper.isEmpty(item.repositoryId)">Uploaded</p>
                          <p v-else>Not Uploaded</p>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-12" v-else>
                      <CRow>
                        <CCol class="col-8 col-xs-8 col-sm-6 col-md-5 col-lg-6 col-xl-4">
                          <p>{{ item.name }}</p>
                        </CCol>
                        <CCol class="col-4 col-xs-4 col-sm-6 col-md-7 col-lg-6 col-xl-8">
                          <p class="custom-text-blue" v-if="!$helper.isEmpty(item.repositoryId)">Uploaded</p>
                          <p v-else>Not Uploaded</p>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol class="col-5 col-xs-5 col-sm-6 col-md-5 col-lg-5 col-xl-6 text-right" v-if="($helper.isRole($availRoles['Cabang']))">
                      <b-spinner small v-if="item.isTransferring" />
                      <div style="display:inline" v-else>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-delete" v-if="$helper.isRole($availRoles['Cabang']) && item.id != null && details.creator" @click="deleteDocument(index)">Delete</span>
                        <span class="custom-link-download-disabled" v-if="($helper.isRole($availRoles['Cabang'])) && item.id != null && !details.creator">Delete</span>
                        <span v-if="$helper.isRole($availRoles['Cabang']) && item.id != null"> | </span>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-download" v-if="$helper.isRole($availRoles['Cabang']) && details.creator" @click="showUploadModal(index)">Upload</span>
                        <span class="custom-link-download-disabled" v-if="($helper.isRole($availRoles['Cabang'])) && !details.creator">Upload</span>
                        <span v-if="$helper.isRole($availRoles['Cabang'])"> | </span>
                        <span @touchstart="onRowHover(index)" @touchend="onRowLeave(index)" @mouseover="onRowHover(index)" @mouseleave="onRowLeave(index)" class="custom-link-download" v-if="($helper.isRole($availRoles['Cabang'])) && !$helper.isEmpty(item.repositoryId)" @click="downloadDocument(index)">Download</span>
                        <span class="custom-link-download-disabled" v-if="($helper.isRole($availRoles['Cabang'])) && $helper.isEmpty(item.repositoryId)">Download</span>
                      </div>
                    </CCol>
                    <b-form-file
                      v-model="item.fileUpload"
                      :accept="item.acceptedExtension"
                      :ref="'document-upload-' + index"
                      v-show="false"
                      @input="uploadDocument($event, index)"
                    ></b-form-file>
                  </CRow>
                </template>
              </CCol>
              <!-- <CCol class="col-12 mt-4" v-if="!$helper.isEmpty(details.documentNotes)">
                <b-alert show variant="light" class="py-0" style="display:flex;align-items:center">
                  <div><b-icon icon="exclamation-triangle" font-scale="2.5" variant="danger" class="my-1 mr-3"></b-icon></div>
                  <div class="py-2" style="overflow: auto;">{{ details.documentNotes }}</div>
                </b-alert>
              </CCol> -->
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mb-2 mx-2">
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Approval Berjenjang</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoadingApproval">
                  <CRow v-for="index in 5" :key="index">
                    <CCol class="col-7 col-xs-7 col-sm-6 col-md-7 col-lg-7 col-xl-6 mb-1">
                      <CRow>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-8 col-lg-12 col-xl-8">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                        <CCol class="col-12 col-xs-12 col-sm-12 col-md-4 col-lg-12 col-xl-4">
                          <Skeleton type="rect" :width="'100%'" :height="'1.33rem'" animation="fade" />
                        </CCol>
                      </CRow>
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow v-for="(item, index) in approval" :key="'approval-' + index">
                    <CCol class="col-4">
                      <strong v-if="item.level === details.approvalLevel">Level {{ item.level }}</strong>
                      <template v-else>Level {{ item.level }}</template>
                    </CCol>
                    <CCol class="col-8">
                      <strong v-if="item.level === details.approvalLevel">
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </strong>
                      <template v-else>
                        : 
                        <span v-for="(value, index2) in item.values" :key="'approval-value-' + index2">
                          {{ index2 != 0 ? ', ' : '' }}{{ value.text }}
                        </span>
                      </template>
                    </CCol>
                  </CRow>
                </template>
              </CCol>
            </CRow>
            <CRow class="mt-4 mb-0 pb-0" v-if="(details.memoStatus == 'RJ' && !$helper.isEmpty(details.rejectNotes)) || (details.memoStatus == 'RV' && !$helper.isEmpty(details.reviseNotes)) ">
              <CCol>
                <!-- <b-alert show variant="warning">
                  <span v-if="details.memoStatus == 'RJ'">{{ details.rejectNotes }}</span>
                  <span v-else-if="details.memoStatus == 'RV'">{{ details.reviseNotes }}</span>
                </b-alert> -->
                <b-alert show variant="warning" v-if="details.memoStatus == 'RV'">
                  <span v-if="!$helper.isEmpty(details.reviseRequestByName)">({{ details.reviseRequestByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.reviseNotes)">{{ details.reviseNotes }}</span>
                </b-alert>
                <b-alert show variant="danger" v-if="details.memoStatus == 'RJ'">
                  <span v-if="!$helper.isEmpty(details.rejectedByName)">({{ details.rejectedByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.rejectNotes)">{{ details.rejectNotes }}</span>
                </b-alert>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol class="col-12 p-1">
        <CCard class="custom-form-card custom-card">
          <CCardBody>
            <CRow>
              <CCol class="col-12">
                <h5 class="custom-header-display">Daftar Collateral</h5>
              </CCol>
            </CRow>
            <CRow>
              <CCol class="col-12 pt-2 custom-detail-list">
                <template v-if="isLoadingAPHT">
                  <CRow>
                    <CCol class="col-12 mb-1">
                      <Skeleton type="rect" :width="'100%'" :height="'5rem'" animation="fade" />
                    </CCol>
                  </CRow>
                </template>
                <template v-else>
                  <CRow>
                    <CCol class="col-12">
                      <b-table striped hover show-empty
                        responsive="xl"
                        :items="details.collateralTable.items"
                        :fields="details.collateralTable.fields"
                        :busy="!details.collateralTable.isLoaded"
                        no-local-sorting no-sort-reset
                        head-variant
                      >
                        <template #cell(namaSertifikatTanah)="row">
                          {{ $helper.showData(row.value, "string") }}
                        </template>
                        <template #cell(nomorSertifikatTanah)="row">
                          {{ $helper.showData(row.value, "string") }}
                        </template>
                        <template #cell(nilaiAppraisal)="row">
                          {{ $helper.showData(row.value, "number") }}
                        </template>
                        <template #cell(notaryFee)="row">
                          {{ $helper.showData(row.value, "number") }}
                        </template>
                        <template #cell(statusHak)="row">
                          {{ $helper.showData(row.value, "string") }}
                        </template>
                        <template #cell(action)="row" v-if="details.creator">
                          <b-button class="mr-2" variant="primary" size="sm" title="Upload Sertifikat" @click="showUploadCertificateModal(row.index)">
                            <template v-if="row.item.isUploading">
                              <b-spinner small label="Uploading..."></b-spinner> Uploading...
                            </template>
                            <template v-else>
                              Upload
                            </template>
                          </b-button>
                          <CButton class="mr-2" color="primary" variant="outline" size="sm" title="Download Sertifikat" @click="downloadCertificate(row.index)" :disabled="$helper.isEmpty(row.item.certificateLandFileId)">
                            <template v-if="row.item.isDownloading">
                              <b-spinner small label="Downloading..."></b-spinner> Downloading...
                            </template>
                            <template v-else>
                              Download
                            </template>
                          </CButton>
                          <b-form-file
                            v-model="row.item.fileUpload"
                            accept=".pdf"
                            :ref="'certificate-upload-' + row.index"
                            v-show="false"
                            @input="uploadCertificate($event, row.index)"
                          ></b-form-file>
                        </template>
                        <template #head(action)>
                          <template v-if="details.creator">
                            Aksi
                          </template>
                        </template>
                        <template slot="empty">
                          <div v-if="!details.collateralTable.isLoaded" class="text-center">
                            <b-spinner label="Fetching Data..."></b-spinner>
                          </div> 
                          <div v-else class="text-center">
                            Tidak ada data
                          </div> 
                        </template>
                      </b-table>
                    </CCol>
                  </CRow>
                </template>
              </CCol>
            </CRow>
            <CRow class="mt-4 mb-0 pb-0" v-if="(details.memoStatus == 'RJ' && !$helper.isEmpty(details.rejectNotes)) || (details.memoStatus == 'RV' && !$helper.isEmpty(details.reviseNotes)) ">
              <CCol>
                <!-- <b-alert show variant="warning">
                  <span v-if="details.memoStatus == 'RJ'">{{ details.rejectNotes }}</span>
                  <span v-else-if="details.memoStatus == 'RV'">{{ details.reviseNotes }}</span>
                </b-alert> -->
                <!-- <b-alert show variant="warning" v-if="details.memoStatus == 'RV'">
                  <span v-if="!$helper.isEmpty(details.reviseRequestByName)">({{ details.reviseRequestByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.reviseNotes)">{{ details.reviseNotes }}</span>
                </b-alert>
                <b-alert show variant="danger" v-if="details.memoStatus == 'RJ'">
                  <span v-if="!$helper.isEmpty(details.rejectedByName)">({{ details.rejectedByName }}) </span>
                  <span v-if="!$helper.isEmpty(details.rejectNotes)">{{ details.rejectNotes }}</span>
                </b-alert> -->
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
      <template v-if="$helper.isRole($availRoles['Cabang'])">
        <template v-if="isLoadingAPHT">
          <CCol class="col-3 offset-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
          <CCol class="col-3 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
        </template>
        <CCol class="col-12 mt-4" v-else>
          <template v-if="details.creator">
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.updateAPHT" v-if="details.memoStatus == 'AP' || details.memoStatus == 'PE'" @click="$router.push({ name: 'APHT Edit', params: { contractMemoNo: $route.params.contractMemoNo } })">
              <b-spinner small v-if="isSubmitting.updateAPHT" />
              <span v-else>Update APHT</span>
            </b-btn>
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.reviseAPHT" v-if="details.memoStatus == 'RV'" @click="$router.push({ name: 'APHT Edit', params: { contractMemoNo: $route.params.contractMemoNo } })">
              <b-spinner small v-if="isSubmitting.reviseAPHT" />
              <span v-else>Revise APHT</span>
            </b-btn>
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.startApproval" v-if="details.memoStatus == 'PE'" @click="startApprovalModalData.isShowing = true">
              <b-spinner small v-if="isSubmitting.startApproval" />
              <span v-else>Start Approval</span>
            </b-btn>
          </template>
          <template v-else-if="details.memoStatus == 'OA'">
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.rejectAPHT" @click="rejectModalData.isShowing = true">
              <b-spinner small v-if="isSubmitting.updateAPHT" />
              <span v-else>Reject APHT</span>
            </b-btn>
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.requestRevision" @click="requestRevisionModalData.isShowing = true">
              <b-spinner small v-if="isSubmitting.requestRevision" />
              <span v-else>Request Revision</span>
            </b-btn>
            <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.approveAPHT" @click="approveModalData.isShowing = true">
              <b-spinner small v-if="isSubmitting.approveAPHT" />
              <span v-else>Approve APHT</span>
            </b-btn>
          </template>
          <!-- <b-form-file
            v-model="uploadCertData.fileUpload"
            accept=".pdf"
            ref="document-upload-cert"
            v-show="false"
            @input="uploadCertificate"
          ></b-form-file>
          <b-form-file
            v-model="uploadDeedData.fileUpload"
            accept=".pdf"
            ref="document-upload-deed"
            v-show="false"
            @input="uploadDeed"
          ></b-form-file> -->
        </CCol>
      </template>
      <template v-else-if="$helper.isRole($availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])">
        <template v-if="isLoadingAPHT">
          <CCol class="col-3 offset-9 mt-4">
            <Skeleton type="rect" :width="'100%'" :height="'1.93rem'" animation="fade" />
          </CCol>
        </template>
        <CCol class="col-12 mt-4" v-else>
          <b-btn variant="primary" class="float-right ml-3 mb-2 btn-sm" style="width:9rem" :disabled="isSubmitting.updateApproval || details.memoStatus != 'OA'" @click="showUpdateApprovalModal">
            <b-spinner small v-if="isSubmitting.updateApproval" />
            <span v-else>Update Approval</span>
          </b-btn>
        </CCol>
      </template>
    </CRow>
    <b-modal
      v-model="addDocumentModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Nama Dokumen:"
              label-for="form-document-name"
              :state="addDocumentModalData.document.name.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.name.value"
                :state="addDocumentModalData.document.name.isValid"
                placeholder="Nama Dokumen"
                id="form-document-name"
                maxlength="256"
              ></b-form-input>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Tipe File"
              label-for="form-document-type"
              :state="addDocumentModalData.document.type.isValid"
            >
              <multiselect 
                v-model="addDocumentModalData.document.type.value" 
                :options="addDocumentModalData.document.type.options" 
                :state="addDocumentModalData.document.type.isValid"
                :class="{custom_multiselect_invalid: addDocumentModalData.document.type.isValid === false}"
                :searchable="false"
                id="form-document-type"
                placeholder="Select an option"
                :showLabels="false"
                openDirection="bottom"
                label="text"
                track-by="text"
              >
                <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                <template slot="option" slot-scope="props">{{ props.option.text }}</template>
              </multiselect>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Kode Grup:"
              label-for="form-document-repo-group"
              :state="addDocumentModalData.document.repositoryGroup.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.repositoryGroup.value"
                :state="addDocumentModalData.document.repositoryGroup.isValid"
                placeholder="Kode Grup"
                id="form-document-repo-group"
                maxlength="10"
              ></b-form-input>
            </b-form-group>
          </CCol>
          <CCol class="col-12">
            <b-form-group
              invalid-feedback="This input is required."
              label="Kode Kategori:"
              label-for="form-document-repo-category"
              :state="addDocumentModalData.document.repositoryCategory.isValid"
            >
              <b-form-input
                v-model="addDocumentModalData.document.repositoryCategory.value"
                :state="addDocumentModalData.document.repositoryCategory.isValid"
                placeholder="Kode Kategori"
                id="form-document-repo-category"
                maxlength="10"
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="addDocumentModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="addDocumentModalData.isSubmitting" @click="addDocument">
              <b-spinner small v-if="addDocumentModalData.isSubmitting" />
              <span v-else>Add</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>
    <b-modal
      v-model="updateApprovalModalData.isShowing"
      title="Update Approval"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-footer
      hide-header-close
      scrollable
      size="xl"
    >
      <CForm>
        <CRow>
          <CCol class="col-12">
            <b-table striped hover show-empty
              responsive="xl"
              :items="updateApprovalModalData.table.items"
              :fields="updateApprovalModalData.table.fields"
              :busy="!updateApprovalModalData.table.isLoaded"
              no-local-sorting no-sort-reset
            >
              <template slot="empty">
                <div v-if="!updateApprovalModalData.table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(approveBy)="row">
                <b-form-select v-model="row.item.approveBy" :options="updateApprovalModalData.table.approveByOptions" @change="onChangeApproveBy(row.index)" style="max-width: 200px;"></b-form-select>
              </template>
              <template #cell(minPokokPembiayaan)="row">
                <b-form-group
                  class="mb-0"
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].minPokokPembiayaan.feedback"
                >
                  <b-form-input
                    :value="$helper.thousandSeparator(row.item.minPokokPembiayaan)"
                    :state="updateApprovalModalData.table.validationItems[row.index].minPokokPembiayaan.isValid"
                    :disabled="row.index == 0"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    @input="row.item.minPokokPembiayaan = $event.toString().replace(/\./g, '')"
                    maxlength="19"
                    type="text"
                    placeholder="Min Pokok Pembiayaan"
                    autocomplete="off"
                    style="max-width: 200px;"
                  ></b-form-input>
                </b-form-group>
              </template>
              <template #cell(values)="row">
                <b-form-group
                  class="mb-0"
                  v-if="row.item.approveBy == 'jobCode'"
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].values.feedback"
                  :state="updateApprovalModalData.table.validationItems[row.index].values.isValid"
                >
                  <multiselect 
                    v-model="row.item.values" 
                    :options="updateApprovalModalData.table.jobCodeData.options" 
                    class="mb-0"
                    :class="{custom_multiselect_invalid: updateApprovalModalData.table.validationItems[row.index].values.isValid === false}"
                    placeholder="Select an option"
                    :showLabels="false"
                    :loading="!updateApprovalModalData.table.jobCodeData.isLoaded"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :internalSearch="false"
                    :multiple="true"
                    :preserveSearch="false"
                    @search-change="populateJobCode"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="updateApprovalModalData.table.jobCodeData.currentPage < updateApprovalModalData.table.jobCodeData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendJobCode" v-if="updateApprovalModalData.table.jobCodeData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-form-group>
                <b-form-group
                  class="mb-0"
                  v-else
                  :invalid-feedback="updateApprovalModalData.table.validationItems[row.index].values.feedback"
                  :state="updateApprovalModalData.table.validationItems[row.index].values.isValid"
                >
                  <multiselect 
                    v-model="row.item.values" 
                    :options="updateApprovalModalData.table.userData.options" 
                    class="mb-0"
                    :class="{custom_multiselect_invalid: updateApprovalModalData.table.validationItems[row.index].values.isValid === false}"
                    placeholder="Select an option"
                    :showLabels="false"
                    :loading="!updateApprovalModalData.table.userData.isLoaded"
                    openDirection="bottom"
                    label="text"
                    track-by="value"
                    :internalSearch="false"
                    :multiple="true"
                    :preserveSearch="false"
                    @search-change="populateUser"
                  >
                    <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                    <template slot="noResult">No elements found.</template>
                    <template slot="afterList" v-if="updateApprovalModalData.table.userData.currentPage < updateApprovalModalData.table.userData.totalPages">
                      <div class="text-center custom-cursor-clickable p-2" @click="appendUser" v-if="updateApprovalModalData.table.userData.isLoaded">
                        <span class="text-muted">Load More</span>
                      </div>
                      <div class="text-center" v-else>
                        <b-spinner small variant="primary" class="m-2 mt-3" label="Loading more options..."></b-spinner>
                      </div>
                    </template>
                  </multiselect>
                </b-form-group>
              </template>
              <template #cell(action)="row">
                <b-button variant="danger" size="sm" title="Remove" @click="removeItem(row.index)" v-if="row.index >= details.approvalLevel">
                  <CIcon name="cil-minus"/>
                </b-button>
              </template>
              <template #head(action)>
                <b-button variant="primary" size="sm" title="Add New Row" @click="addItem"><CIcon name="cil-plus"/></b-button>
              </template>
            </b-table>
          </CCol>
        </CRow>
        <CRow class="mt-1 float-right">
          <CCol class="col-12">
            <b-btn variant="secondary" class="mr-3" @click="updateApprovalModalData.isShowing = false">Cancel</b-btn>
            <b-btn variant="primary" type="submit" style="width:4rem" :disabled="updateApprovalModalData.isSubmitting" @click="updateApproval">
              <b-spinner small v-if="updateApprovalModalData.isSubmitting" />
              <span v-else>Save</span>
            </b-btn>
          </CCol>
        </CRow>
      </CForm>
    </b-modal>

    <CModal :closeOnBackdrop="false" :show.sync="approveModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Persetujuan Kontrak APHT</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menyetujui pengajuan kontrak APHT ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Kontrak Memo No.
          </CCol>
          <CCol md="8" sm="7">
            : {{ $route.params.contractMemoNo }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Pokok Pembiayaan
          </CCol>
          <CCol md="8" sm="7">
            : Rp{{ $helper.showData(details.pokokPembiayaan, "number") }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="approveModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmApproveAPHT" :disabled="approveModalData.isLoading">
          <b-spinner small type="grow" v-if="approveModalData.isLoading" /> 
          {{ approveModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="startApprovalModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Memulai Approval</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin memulai Approval kontrak APHT ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Kontrak Memo No.
          </CCol>
          <CCol md="8" sm="7">
            : {{ $route.params.contractMemoNo }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Pokok Pembiayaan
          </CCol>
          <CCol md="8" sm="7">
            : Rp{{ $helper.showData(details.pokokPembiayaan, "number") }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="startApprovalModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmStartApproval" :disabled="startApprovalModalData.isLoading">
          <b-spinner small type="grow" v-if="startApprovalModalData.isLoading" /> 
          {{ startApprovalModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="rejectModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Penolakan Kontrak APHT</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menolak pengajuan kontrak APHT ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Kontrak Memo No.:"
              label-for="modal-reject-contractMemoNo"
            >
              <b-form-input
                v-model="$route.params.contractMemoNo"
                id="modal-reject-contractMemoNo"
                maxlength="500"
                disabled
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Reject Note:"
              label-for="modal-reject-note"
              :state="rejectModalData.rejectNote.isValid"
            >
              <b-form-textarea
                v-model="rejectModalData.rejectNote.value"
                :state="rejectModalData.rejectNote.isValid"
                placeholder="Reject Note"
                id="modal-reject-note"
                rows="4"
                max-rows="4"
                maxlength="500"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="rejectModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmRejectAPHT" :disabled="rejectModalData.isLoading">
          <b-spinner small type="grow" v-if="rejectModalData.isLoading" /> 
          {{ rejectModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="requestRevisionModalData.isShowing" :centered="true">
      <div slot="header"><h5>Konfirmasi Revisi Kontrak APHT</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin merevisi pengajuan kontrak APHT ini?
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Kontrak Memo No.:"
              label-for="modal-reject-contractMemoNo"
            >
              <b-form-input
                v-model="$route.params.contractMemoNo"
                id="modal-reject-contractMemoNo"
                maxlength="500"
                disabled
              ></b-form-input>
            </b-form-group>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <b-form-group
              invalid-feedback="This input is required."
              label="Revise Note:"
              label-for="modal-revise-note"
              :state="requestRevisionModalData.reviseNote.isValid"
            >
              <b-form-textarea
                v-model="requestRevisionModalData.reviseNote.value"
                :state="requestRevisionModalData.reviseNote.isValid"
                placeholder="Revise Note"
                id="modal-revise-note"
                rows="4"
                max-rows="4"
                maxlength="500"
              ></b-form-textarea>
            </b-form-group>
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="secondary" @click="requestRevisionModalData.isShowing = false">Batal</CButton>
        <CButton class="ml-2" color="primary" @click="confirmReviseAPHT" :disabled="requestRevisionModalData.isLoading">
          <b-spinner small type="grow" v-if="requestRevisionModalData.isLoading" /> 
          {{ requestRevisionModalData.isLoading ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>
    <b-modal
      v-model="reGenerateDocumentModalData.isShowing"
      no-close-on-backdrop
      no-close-on-esc
      centered
      hide-header
      hide-footer
      scrollable
    >
      <CRow>
        <CCol class="col-12">
          Apakah Anda yakin ingin melakukan generate ulang dokumen pada kontrak ini?
        </CCol>
      </CRow>
      <CRow class="mt-1 float-right">
        <CCol class="col-12">
          <b-btn variant="secondary" class="mr-3" @click="reGenerateDocumentModalData.isShowing = false">Cancel</b-btn>
          <b-btn variant="primary" type="button" style="width:10rem" :disabled="reGenerateDocumentModalData.isSubmitting" @click="reGenerateDocument">
            <b-spinner small v-if="reGenerateDocumentModalData.isSubmitting" />
            <span v-else>Re-Generate</span>
          </b-btn>
        </CCol>
      </CRow>
    </b-modal>
  </CContainer>
</template>


<script>
export default {
  name: 'FiduciaDetail',
  data() {
    return {

      approveModalData: {
        isShowing: false,
        isLoading: false,
      },

      startApprovalModalData: {
        isShowing: false,
        isLoading: false,
      },

      requestRevisionModalData: {
        isShowing: false,
        isLoading: false,
        reviseNote: {
          value: '',
          isValid: null,
          isRequired: false,
        }
      },

      rejectModalData: {
        isShowing: false,
        isLoading: false,
        rejectNote: {
          value: '',
          isValid: null,
          isRequired: false,
        }
      },

      isLoadingAPHT: true,
      isLoadingApproval: true,

      isSubmitting: {
        updateAPHT: false,
        reviseAPHT: false,
        updateApproval: false,
        rejectAPHT: false,
        requestRevision: false,
        approveAPHT: false,
        startApproval: false,
      },

      details: {
        // documentNotes: '',
        // documentStatus: '',
        approvalLevel: -1,
        contractType: '',
        contractNo: '',
        officeCode: '',
        officeName: '',
        contractStatus: '',
        contractDate: '',
        notaryName: '',
        notes: '',
        assignmentDate: '',
        customerName: '',
        customerAddress: '',
        customerDob: '',
        customerKtp: '',
        bussUnit: '',
        mouType: '',
        aktaAvailable: false,
        certificateAvailable: false,
        memoStatus: null,
        rejectNotes: null,
        reviseNotes: null,
        reviseRequestByName: '',
        rejectedByName: '',
        creator: false,
        applNo: '',
        listDocument: [],
        collateralTable: {
          isLoaded: false,
          // table fields mirrors returned object from server-side
          fields: [
            {key: "namaSertifikatTanah", label: "Nama Sertifikat", sortable: false},
            {key: "nomorSertifikatTanah", label: "Nomor Sertifikat", sortable: false},
            {key: "nilaiAppraisal", label: "Nilai Appraisal", sortable: false},
            {key: "notaryFee", label: "Biaya Notaris", sortable: false},
            {key: "statusHak", label: "Status Hak", sortable: false},
            { key: "action", label: "", sortable: false}
          ],
          items: [],
          sortBy: null,
          sortDesc: true,
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0
        }
      },
      approval: [],
      
      addDocumentModalData: {
        isShowing: false,
        isSubmitting: false,
        document: {
          name: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "name"
          },
          repositoryGroup: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "repoGroup"
          },
          repositoryCategory: {
            value: '',
            isValid: null,
            isRequired: true,
            payloadKey: "repoCategory"
          },
          type: {
            value: '',
            isValid: null,
            isRequired: true,
            options: [
              { value: "file", text: "File" },
              { value: "image", text: "Image" }
            ],
            payloadKey: "type"
          }
        }
      },

      updateApprovalModalData: {
        isShowing: false,
        table: {
          isLoaded: false,
          fields: [
            {key: "level", label: "Level", sortable: false},
            {key: "approveBy", label: "Approve By", sortable: false},
            {key: "values", label: "Value", sortable: false},
            {key: "minPokokPembiayaan", label: "Min Pokok Pembiayaan", sortable: false},
            {key: "action", label: "", sortable: false}
          ],

          items: [],

          validationItems: [],

          template: {
            approveBy: "jobCode",
            level: 1,
            minPokokPembiayaan: 0,
            values: []
          },

          validationTemplate: {
            minPokokPembiayaan: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "minPokokPembiayaan"
            },
            values: {
              isValid: null,
              feedback: 'This input is required.',
              isRequired: true,
              payloadKey: "values"
            },
          },

          approveByOptions: [
            { value: "jobCode", text: "Job Code" },
            { value: "user", text: "User" },
          ],

          jobCodeData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          userData: {
            isLoaded: false,
            isValid: null,
            isRequired: true,
            options: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,
            lastQuery: '',
          },

          currentPage: 1,
        },
        isSubmitting: false
      },
      reGenerateDocumentModalData: {
        isShowing: false,
        isSubmitting: false
      }
    }
  },
  methods: {
    showReGenerateDocumentModal(){
      this.reGenerateDocumentModalData.isShowing = true
    },

    clearAddDocumentModalData(){
      this.addDocumentModalData.document.name.value = ''
      this.addDocumentModalData.document.repositoryGroup.value = ''
      this.addDocumentModalData.document.repositoryCategory.value = ''
      this.addDocumentModalData.document.type.value = ''
      this.addDocumentModalData.document.name.isValid = null
      this.addDocumentModalData.document.repositoryGroup.isValid = null
      this.addDocumentModalData.document.repositoryCategory.isValid = null
      this.addDocumentModalData.document.type.isValid = null
    },

    confirmStartApproval() {
      this.startApprovalModalData.isLoading = true

      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        let processUrl = "/apht/startApproval";
        let data = new FormData();
        data.set('contractMemoNo', this.$route.params.contractMemoNo);
        data.set('pokokPembiayaan', this.details.pokokPembiayaan);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$store.commit('set', ['toast', true])
            this.$store.commit('set', ['toastMsg', "Start Approval APHT Sukses! " + (response.data.reason ? response.data.reason : "")])
            this.$router.go()
          } else {
            this.$helper.toastError(this, "Start Approval Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Approve APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Approve APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.startApprovalModalData.isLoading = false
        })
      }
    },

    confirmApproveAPHT() {
      this.approveModalData.isLoading = true

      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        let processUrl = "/apht/approve";
        let data = new FormData();
        data.set('contractMemoNo', this.$route.params.contractMemoNo);
        data.set('pokokPembiayaan', this.details.pokokPembiayaan);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$store.commit('set', ['toast', true])
            this.$store.commit('set', ['toastMsg', "Approve APHT Sukses! " + (response.data.reason ? response.data.reason : "")])
            this.$router.push('/apht/need-approval')
          } else {
            this.$helper.toastError(this, "Approve APHT Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Approve APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Approve APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.approveModalData.isLoading = false
        })
      }
    },

    confirmRejectAPHT() {
      let isFormValid = true
      
      if (this.$helper.isEmpty(this.rejectModalData.rejectNote.value)) {
        this.rejectModalData.rejectNote.isValid = false
        isFormValid = false
      } else{
        this.rejectModalData.rejectNote.isValid = null
      }

      if(this.$helper.isRole(this.$availRoles['Cabang']) && isFormValid){
        this.rejectModalData.isLoading = true

        let processUrl = "/apht/reject";
        let data = new FormData();
        data.set('contractMemoNo', this.$route.params.contractMemoNo);
        data.set('rejectNotes', this.rejectModalData.rejectNote.value);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$store.commit('set', ['toast', true])
            this.$store.commit('set', ['toastMsg', "Reject APHT Sukses! " + (response.data.reason ? response.data.reason : "")])
            this.$router.push('/apht/need-approval')
          } else {
            this.$helper.toastError(this, "Reject APHT Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Reject APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Reject APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.rejectModalData.isLoading = false
        })
      }
    },

    confirmReviseAPHT() {
      let isFormValid = true
      
      if (this.$helper.isEmpty(this.requestRevisionModalData.reviseNote.value)) {
        this.requestRevisionModalData.reviseNote.isValid = false
        isFormValid = false
      } else{
        this.requestRevisionModalData.reviseNote.isValid = null
      }

      if(isFormValid){
        this.requestRevisionModalData.isLoading = true

        let processUrl = "/apht/revise";
        let data = new FormData();
        data.set('contractMemoNo', this.$route.params.contractMemoNo);
        data.set('reviseNotes', this.requestRevisionModalData.reviseNote.value);
        this.$axios.post(processUrl, data).then((response) => {
          if (response.status === 200){
            this.$store.commit('set', ['toast', true])
            this.$store.commit('set', ['toastMsg', "Revise APHT Sukses! " + (response.data.reason ? response.data.reason : "")])
            this.$router.push('/apht/need-approval')
          } else {
            this.$helper.toastError(this, "Revise APHT Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Revise APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Revise APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.requestRevisionModalData.isLoading = false
        })
      }
    },

    async showUpdateApprovalModal() {
      Promise.all([this.populateJobCode(), this.populateUser(), this.getTableItems()])
        .then(() => {
          for(let i = 0; i < this.updateApprovalModalData.table.validationItems.length; i++){
            this.updateApprovalModalData.table.validationItems[i].values.isValid = null
            this.updateApprovalModalData.table.validationItems[i].minPokokPembiayaan.isValid = null
          }
          this.updateApprovalModalData.isShowing = true
        })
    },

    updateApproval(event) {
      event.preventDefault()

      let isFormValid = true
      let obj = {}

      // Validation
      let index = 0
      let prevMinPokokPembayaran = 0
      for(const item of this.updateApprovalModalData.table.items) {
        if (item.values.length == 0) {
          this.updateApprovalModalData.table.validationItems[index].values.isValid = false
          isFormValid = false
        } else{
          this.updateApprovalModalData.table.validationItems[index].values.isValid = null
        }

        if (item.minPokokPembiayaan === '') {
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.feedback = "This input is required."
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else if (Number(item.minPokokPembiayaan) < prevMinPokokPembayaran) {
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.feedback = "Amount must be greater than or equals to previous amount."
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = false
          isFormValid = false
        } else{
          this.updateApprovalModalData.table.validationItems[index].minPokokPembiayaan.isValid = null
        }

        prevMinPokokPembayaran = Number(item.minPokokPembiayaan)
        index++
      }

      if (isFormValid) {
        obj.approvers = this.updateApprovalModalData.table.items
        obj.contractMemoNo = this.$route.params.contractMemoNo
        let postUrl = '/apht/editApprovers'
        
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Set Approval Berjenjang Berhasil!" + (response.data.reason ? response.data.reason : ""))
              this.getAPHTApproval(this.$route.params.contractMemoNo)
              this.updateApprovalModalData.isShowing = false
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Set Approval Berjenjang Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    removeItem(index) {
      this.updateApprovalModalData.table.items.splice(index, 1)
      this.updateApprovalModalData.table.validationItems.splice(index, 1)
      this.reorganizeItemLevels()

      if (index == 0) this.updateApprovalModalData.table.items[0].minPokokPembiayaan = 0
    },

    reorganizeItemLevels() {
      let index = 1
      this.updateApprovalModalData.table.items.forEach(item => {
        item.level = index++
      })
    },

    getTableItems() {
      this.updateApprovalModalData.table.isLoaded = false

      this.updateApprovalModalData.table.items = this.$lodash.cloneDeep(this.approval)
      for(let i = 0; i < this.approval.length; i++) {
        this.addValidationItemOnly()
      }
      this.updateApprovalModalData.table.isLoaded = true
    },

    addItem() {
      let item = this.$lodash.cloneDeep(this.updateApprovalModalData.table.template)
      let validationItem = this.$lodash.cloneDeep(this.updateApprovalModalData.table.validationTemplate)
      item.level = (this.updateApprovalModalData.table.items.length+1)
      this.updateApprovalModalData.table.items.push(item)
      this.updateApprovalModalData.table.validationItems.push(validationItem)
    },

    addValidationItemOnly() {
      let validationItem = this.$lodash.cloneDeep(this.updateApprovalModalData.table.validationTemplate)
      this.updateApprovalModalData.table.validationItems.push(validationItem)
    },

    onChangeApproveBy(index) {
      this.updateApprovalModalData.table.items[index].values = []
    },

    async populateJobCode(query = "") {
      this.updateApprovalModalData.table.jobCodeData.isLoaded = false
      this.updateApprovalModalData.table.jobCodeData.totalPages = 0
      this.updateApprovalModalData.table.jobCodeData.totalRows = 0
      this.updateApprovalModalData.table.jobCodeData.currentPage = 1
      this.updateApprovalModalData.table.jobCodeData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      let params = {}
      // get content from current page
      params['page'] = (this.updateApprovalModalData.table.jobCodeData.currentPage - 1)
      params['size'] = this.updateApprovalModalData.table.jobCodeData.perPage
      if(query !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = query
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.updateApprovalModalData.table.jobCodeData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.updateApprovalModalData.table.jobCodeData.totalRows = response.data.data.totalElements
            this.updateApprovalModalData.table.jobCodeData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    async populateUser(query = "") {
      this.updateApprovalModalData.table.userData.isLoaded = false
      this.updateApprovalModalData.table.userData.totalPages = 0
      this.updateApprovalModalData.table.userData.totalRows = 0
      this.updateApprovalModalData.table.userData.currentPage = 1
      this.updateApprovalModalData.table.userData.lastQuery = query
      // URL builder
      let getUrl = "/approver/getUserCabang"
      let params = {}
      // get content from current page
      params['page'] = (this.updateApprovalModalData.table.userData.currentPage - 1)
      params['size'] = this.updateApprovalModalData.table.userData.perPage
      if(query !== ""){
        params['filterType'] = "fullName"
        params['filterValue'] = query
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            this.updateApprovalModalData.table.userData.options = []
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.updateApprovalModalData.table.userData.totalRows = response.data.data.totalElements
            this.updateApprovalModalData.table.userData.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendJobCode() {
      this.updateApprovalModalData.table.jobCodeData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getJobCodeCabang"
      let params = {}
      // get content from next page
      params['page'] = (this.updateApprovalModalData.table.jobCodeData.currentPage)
      params['size'] = this.updateApprovalModalData.table.jobCodeData.perPage
      if(this.updateApprovalModalData.table.jobCodeData.lastQuery !== ""){
        params['filterType'] = "jobName"
        params['filterValue'] = this.updateApprovalModalData.table.jobCodeData.lastQuery
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.jobCodeData.options.push({ value: response.data.data.data[i].jobCode, text: response.data.data.data[i].jobName })
            }
            this.updateApprovalModalData.table.jobCodeData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Job Code Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.jobCodeData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    appendUser() {
      this.updateApprovalModalData.table.userData.isLoaded = false
      // URL builder
      let getUrl = "/approver/getUserCabang"
      let params = {}
      // get content from next page
      params['page'] = (this.updateApprovalModalData.table.userData.currentPage)
      params['size'] = this.updateApprovalModalData.table.userData.perPage
      if(this.updateApprovalModalData.table.userData.lastQuery !== ""){
        params['filterType'] = "fullName"
        params['filterValue'] = this.updateApprovalModalData.table.userData.lastQuery
      }
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['FIMS'])){
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            for(let i = 0; i < response.data.data.data.length; i++){
              this.updateApprovalModalData.table.userData.options.push({ value: response.data.data.data[i].id, text: response.data.data.data[i].fullName })
            }
            this.updateApprovalModalData.table.userData.currentPage++
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar User Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
          }
          else{
            this.$helper.toastError(this, "Load Daftar User Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.updateApprovalModalData.table.userData.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    onRowHover(idx){
      this.details.listDocument[idx].isHovered = true
    },
    onRowLeave(idx){
      this.details.listDocument[idx].isHovered = false
    },
    async getAPHT(contractMemoNo){
      this.isLoadingAPHT = true
      let getUrl = "/apht/getDetail"
      let params = {}
      params['contractMemoNo'] = contractMemoNo
      return await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.details.officeName = response.data.data.officeNameShort
          this.details.memoStatus = response.data.data.memoStatus
          this.details.approvalLevel = response.data.data.approvalLevel
          switch (response.data.data.memoStatus) {
            case 'PE':
              this.details.memoStatusName = 'Draft'
              break
            case 'OA':
              this.details.memoStatusName = 'On Approval'
              break
            case 'AP':
              this.details.memoStatusName = 'Approved'
              break
            case 'RJ':
              this.details.memoStatusName = 'Rejected'
              this.details.rejectedByName = response.data.data.rejectedByName
              this.details.rejectNotes = response.data.data.rejectNotes
              break
            case 'RV':
              this.details.memoStatusName = 'Need Revise'
              this.details.reviseRequestByName = response.data.data.reviseRequestByName
              this.details.reviseNotes = response.data.data.reviseNotes
              break
          }
          this.details.createdAt = response.data.data.createdAt
          this.details.objectPrice = response.data.data.objectPrice
          this.details.notaryFee = response.data.data.notaryFee
          this.details.notes = response.data.data.notes
          this.details.applNo = response.data.data.applNo
          this.details.contractNo = response.data.data.contractNo
          this.details.customerName = response.data.data.customerName
          this.details.nilaiPenjaminan = response.data.data.nilaiPenjaminan
          this.details.pokokPembiayaan = response.data.data.pokokPembiayaan
          this.details.creator = response.data.data.creator
          // this.details.customerName = response.data.data.customerName
          // this.details.customerAddress = response.data.data.customerAddress
          // this.details.customerDob = response.data.data.customerDob
          // this.details.customerKtp = response.data.data.customerKtp
          // this.details.bussUnit = response.data.data.bussUnit
          // this.details.mouType = response.data.data.mouType
          // this.details.aktaAvailable = response.data.data.aktaAvailable
          // this.details.certificateAvailable = response.data.data.certificateAvailable
          this.details.listDocument = response.data.data.listDocument.map(item => {
            let formattedExtension = item.extension.map(ext => {
              return "." + ext
            })
            let acceptedExtension = formattedExtension.join(", ")
            return {
              "id": item.id,
              "name": item.name,
              "repoGroup": item.repoGroup,
              "repoCategory": item.repoCategory,
              "repositoryId": item.repositoryId,
              "extension": item.extension,
              "extensionFile": item.extensionFile,
              "acceptedExtension": acceptedExtension,
              "fileUpload": null,
              "isTransferring": false,
              "isHovered": false
            }
          })
          this.details.collateralTable.items = response.data.data.listCollateral.map(obj => {
            obj.isDownloading = false
            obj.isUploading = false
            obj.fileUpload = null
            return obj
          })
          this.details.collateralTable.isLoaded = true
          return true
        }
        else{
          this.$helper.toastError(this, "Load Detail APHT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Detail APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Detail APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoadingAPHT = false
      })
    },
    async getAPHTApproval(contractMemoNo){
      this.isLoadingApproval = true
      let getUrl = "/apht/getApprovers"
      let params = {}
      params['contractMemoNo'] = contractMemoNo
      await this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          this.approval = response.data.data
        }
        else{
          this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
        }
        else{
          this.$helper.toastError(this, "Load Approval Berjenjang APHT Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoadingApproval = false
      })
    },
    showUploadModal(idx) {
      this.$refs['document-upload-' + idx][0].$el.childNodes[0].click()
    },
    showAddDocumentModal(){
      this.clearAddDocumentModalData()
      this.addDocumentModalData.isShowing = true
    },
    addDocument(event){
      event.preventDefault()
      // validate form entries before submit
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.addDocumentModalData.document)){
        // check multiselect fields
        if(key == "type"){
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
        // check remaining fields
        else{
          if(!this.$helper.isEmpty(data.value)){
            data.isValid = null
            obj[data.payloadKey] = data.value
          }
          else if(data.isRequired){
            data.isValid = false
            isFormValid = false
          }
          else{
            data.isValid = null
          }
        }
      }
      // submit form data if every field is valid
      if(isFormValid){
        obj["contractMemoNo"] = this.$route.params.contractMemoNo
        let postUrl = '/contractDocument/addApht'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang']) && this.details.creator){
          this.addDocumentModalData.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.$helper.toastSuccess(this, "Create Dokumen Berhasil!")
              this.addDocumentModalData.isShowing = false
              this.getAPHT(this.$route.params.contractMemoNo)
            }
            else{
              this.$helper.toastError(this, "Create Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Create Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.addDocumentModalData.isSubmitting = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },
    deleteDocument(idx){
      let payload = new FormData()
      payload.append("id", this.details.listDocument[idx].id)
      let postUrl = '/contractDocument/delete'
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) && this.details.creator){
        this.details.listDocument[idx].isTransferring = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.$helper.toastSuccess(this, "Delete Dokumen Berhasil!")
            this.getAPHT(this.$route.params.contractMemoNo)
          }
          else{
            this.$helper.toastError(this, "Delete Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Delete Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Delete Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.listDocument[idx].isTransferring = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    uploadDocument(file, idx){
      let isFormValid = true
      let payload = new FormData()
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/contractDocument/uploadDocApht'
        let allowedExtension = this.details.listDocument[idx].extension
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("repoCategory", this.details.listDocument[idx].repoCategory)
        payload.append("contractMemoNo", this.$route.params.contractMemoNo)
        payload.append("repoGroup", this.details.listDocument[idx].repoGroup)
        payload.append("allowedExtension", JSON.stringify(allowedExtension))
        payload.append("extension", fileExt)
        payload.append("file", file)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang']) && this.details.creator){
          this.details.listDocument[idx].isTransferring = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.details.listDocument[idx].repositoryId = response.data.data
              this.details.listDocument[idx].extensionFile = fileExt
              this.$helper.toastSuccess(this, "Upload Dokumen Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Upload Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Upload Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
          })
          .finally(() => {
            this.details.listDocument[idx].isTransferring = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    showUploadCertificateModal(idx) {
      this.$refs['certificate-upload-' + idx].$el.childNodes[0].click()
    },

    uploadCertificate(file, idx) {
      let isFormValid = true
      let payload = new FormData()
      if(file.size > this.$uploadLimit){
        this.$helper.toastError(this, "Mohon upload dokumen dengan size lebih rendah dari 1 MB")
        isFormValid = false
      }
      // submit form data if every field is valid
      if(isFormValid){
        let postUrl = '/apht/uploadLandCertificate'
        let fileNameSplit = file.name.split(".")
        let fileExt = fileNameSplit[fileNameSplit.length-1]
        payload.append("collateralAphtId", this.details.collateralTable.items[idx].id)
        payload.append("file", file)
        payload.append("extension", fileExt)
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['Cabang'])){
          this.details.collateralTable.items[idx].isUploading = true
          this.$axios.post(postUrl, payload).then(response => {
            if(response.status == 200){
              this.details.collateralTable.items[idx].certificateLandFileId = response.data.data
              this.$helper.toastSuccess(this, "Upload Sertifikat Berhasil!")
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
            }
            else{
              this.$helper.toastError(this, "Upload Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.details.collateralTable.items[idx].isUploading = false
          })
        }
        else{
          this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
        }
      }
    },

    downloadDocument(idx) {
      let payload = new FormData()
      let postUrl = '/contractDocument/download/byte'
      payload.append("repositoryId", this.details.listDocument[idx].repositoryId)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['Notaris'])){
        this.details.listDocument[idx].isTransferring = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.details.listDocument[idx].repositoryId + "." + this.details.listDocument[idx].extensionFile
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.listDocument[idx].isTransferring = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },

    downloadCertificate(idx) {
      let payload = new FormData()
      let postUrl = '/apht/downloadLandCertificate'
      payload.append("collateralAphtId", this.details.collateralTable.items[idx].id)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang'])){
        this.details.collateralTable.items[idx].isDownloading = true
        this.$axios.post(postUrl, payload, {
          // necessary to avoid encoding returned bytes
          responseType: 'blob'
        }).then(response => {
          if(response.status == 200){
            // create file Blob and download according to extension
            let blob=new Blob([response.data], {type: "application/octet-stream"})
            let link=document.createElement('a')
            link.href=window.URL.createObjectURL(blob)
            link.download= this.details.collateralTable.items[idx].id + ".pdf"
            link.click();
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Download Sertifikat Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Download Sertifikat Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.details.collateralTable.items[idx].isDownloading = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    },
    reGenerateDocument(){
      let payload = new FormData()
      let postUrl = '/contractDocument/regenerate'
      payload.append("applNo", this.details.applNo)
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO']) || this.$helper.isRole(this.$availRoles['Cabang'])){
        this.reGenerateDocumentModalData.isSubmitting = true
        this.$axios.post(postUrl, payload).then(response => {
          if(response.status == 200){
            this.reGenerateDocumentModalData.isShowing = false
            this.$helper.toastSuccess(this, "Generate Ulang Dokumen Berhasil!")
          }
          else{
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Generate Ulang Dokumen Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.reGenerateDocumentModalData.isSubmitting = false
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
    
  },
  async created(){
    let success = await this.getAPHT(this.$route.params.contractMemoNo);
    if (success) this.getAPHTApproval(this.$route.params.contractMemoNo);

    if (this.$store.state.toast) {
      this.$helper.toastSuccess(this, this.$store.state.toastMsg)
      this.$store.commit('set', ['toast', false])
      this.$store.commit('set', ['toastMsg', ''])
    }
  },

  async mounted(){
    // Promise.all([
    //   this.getAPHT(this.$route.params.contractMemoNo),
    //   this.getAPHTApproval(this.$route.params.contractMemoNo)
    // ])
    // .then(() => {
    //   // this.showUpdateApprovalModal()
    // })

    // if (this.$store.state.toast) {
    //   this.$helper.toastSuccess(this, this.$store.state.toastMsg)
    //   this.$store.commit('set', ['toast', false])
    //   this.$store.commit('set', ['toastMsg', ''])
    // }
  }
}
</script>

<style scoped>
.btn.custom-button-disabled:disabled{
  cursor: default !important;
}
</style>
